import { useCallback, useState } from 'react'
import { Button, Text } from '@leroy-merlin-br/backyard-react-ui'
import { InfoCircleSolid } from '@leroy-merlin-br/backyard-react-icons'

import { Notification } from 'checkout/components/Notification'

import * as S from './styled'

const ConditionsOfUse = ({ hasService }) => {
  const [showMessage, setShowMessage] = useState(false)

  const handleShowMessage = useCallback(() => setShowMessage(true), [
    setShowMessage
  ])

  const handleHideMessage = useCallback(() => setShowMessage(false), [
    setShowMessage
  ])

  if (showMessage) {
    return (
      <S.Conditions>
        <Notification hasClose={true} onClose={handleHideMessage}>
          <Text size="kilo" noMargin>
            Os Cupons são aplicáveis{' '}
            <Text as="strong" size="kilo" noMargin bold>
              apenas a produtos sem descontos{' '}
            </Text>
            e não são cumulativos, portanto, você só pode utilizar{' '}
            <Text as="strong" size="kilo" noMargin bold>
              um cupom por compra
            </Text>.{' '}
            {
              hasService && (
                <Text as="span" size="kilo" noMargin>
                  Nenhum{' '}
                  <Text as="strong" size="kilo" noMargin bold>
                    serviço de instalação será elegível{' '}
                  </Text>
                  a nenhum tipo de cupom ou desconto.{' '}
                </Text>
              )
            }
            Para aplicar um vale-compra o valor total do carrinho deve ser{' '}
            <Text as="strong" size="kilo" noMargin bold>
              superior ao valor de desconto
            </Text>.
          </Text>
        </Notification>
      </S.Conditions>
    )
  }

  return (
    <S.Conditions>
      <Button
        size="kilo"
        variant="link"
        color="gray"
        iconLeft={InfoCircleSolid}
        onClick={handleShowMessage}
      >
        Condições de uso
      </Button>
    </S.Conditions>
  )
}

export default ConditionsOfUse
